// API Configuration for CODiii Subscription Management

// Get API URL from environment variable or use default
export const SUBSCRIPTION_API_URL = process.env.REACT_APP_SUBSCRIPTION_API_URL || 
  'https://api.example.com'; // Placeholder - replace with actual API Gateway URL

// API Endpoints
export const API_ENDPOINTS = {
  // Subscription Management
  TEAM_USERS: `${SUBSCRIPTION_API_URL}/subscription/team-users`,
  SUBSCRIPTION_DETAILS: `${SUBSCRIPTION_API_URL}/subscription/subscription-details`,
  ADD_USER: `${SUBSCRIPTION_API_URL}/subscription/add-user`,
  UPDATE_USER_STATUS: `${SUBSCRIPTION_API_URL}/subscription/update-user-status`,
  UPDATE_USER_ROLE: `${SUBSCRIPTION_API_URL}/subscription/update-user-role`,
  DELETE_USER: `${SUBSCRIPTION_API_URL}/subscription/delete-user`,
};

// Helper function to make API calls
export const apiCall = async (endpoint, options = {}) => {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const response = await fetch(endpoint, {
    ...defaultOptions,
    ...options,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
  }

  return response.json();
};

// Check if API is configured
export const isApiConfigured = () => {
  const configured = SUBSCRIPTION_API_URL !== 'https://api.example.com';
  console.log('API Configuration check:', {
    SUBSCRIPTION_API_URL,
    isConfigured: configured
  });
  return configured;
}; 